import React from "react";
import { useDispatch } from "react-redux";

import KPTable from "../../../../components/KPTComponents/KPTable";

import { ActionColumn } from "../../../../containers/DangKyHoSo/utils";
import { AWARD_MODEL, CRUD_MODELS } from "../../../../constants";
import { Chip } from "@mui/material";

function TacPhamTable({ rows, setDialog, ...props }) {
  const dispatch = useDispatch();

  const columns = [
    { ...AWARD_MODEL.title, width: "35%" },
    {
      ...AWARD_MODEL.level,
      width: "25%",
      filters: AWARD_MODEL.level.options,
      render: (value) =>
        AWARD_MODEL.level.options.find((e) => e.value === value)?.title,
      onFilter: (value, row) => row.level === value,
    },
    { ...AWARD_MODEL.authorNumber, width: "5%" },
    // {
    //   key: "link",
    //   label: "Tác vụ",
    //   width: "20%",
    //   render: (_, row) => (
    //     <ActionColumn
    //       row={row}
    //       type={CRUD_MODELS.AWARD}
    //       setDialog={setDialog}
    //       setDuyetThanhTich={props.setDuyetThanhTich}
    //       setPreview={props.setPreview}
    //       setDeleteCrud={props.setDeleteCrud}
    //       setChoDiem={props.setChoDiem}
    //     />
    //   ),
    // },
  ];

  if (props.setDuyetThanhTich) {
    // columns.push({
    //   key: "numberAuthor",
    //   label: "Số tác giả",
    //   align: "center",
    //   width: "5%",
    //   render: (_, row) => row.numberAuthor,
    // });
    // columns.push({
    //   key: "numberMain",
    //   label: "Số chủ biên",
    //   align: "center",
    //   width: "5%",
    //   render: (_, row) => row.numberMain,
    // });
    columns.push({
      key: "point",
      label: "Điểm",
      align: "center",
      width: "5%",
      render: (_, row) => row.scoringTable?.point,
    });
    columns.push({
      key: "point",
      label: "Điểm tối đa",
      align: "center",
      width: "5%",
      render: (_, row) => row.scoringTable?.maxPoint,
    });
    columns.push({
      key: "note",
      label: "Ghi chú",
      align: "center",
      width: "10%",
      render: (_, row) => row.scoringTable?.note,
    });
    columns.push({
      key: "accepted",
      label: "Trạng thái",
      align: "center",
      width: "15%",
      render: (_, row) => (
        <Chip
          size="small"
          color={
            row.scoringTable?.accepted || row?.notEligible
              ? "primary"
              : "default"
          }
          label={
            row.scoringTable?.accepted || row?.notEligible
              ? "Đã chấm"
              : "Chưa chấm"
          }
          variant={
            row.scoringTable?.accepted || row?.notEligible
              ? "filled"
              : "outlined"
          }
        />
      ),
    });
  }

  columns.push({
    key: "link",
    label: "Tác vụ",
    width: "20%",
    render: (_, row) => (
      <ActionColumn
        row={row}
        type={CRUD_MODELS.AWARD}
        setDialog={setDialog}
        setDuyetThanhTich={props.setDuyetThanhTich}
        setPreview={props.setPreview}
        setDeleteCrud={props.setDeleteCrud}
        setChoDiem={props.setChoDiem}
      />
    ),
  });

  return (
    <KPTable
      columns={columns}
      nonBorder={!!props.nonBorder}
      rows={rows}
      // loading={loading}
    />
  );
}

export default TacPhamTable;
